import LazyLoad from './modules/lazyload';
import { addNewTooltipsToButtonGroup } from './modules/tooltips';

var Advisor = function Advisor() {
  var mobileBreakpoint = 768;
  var cls_selected = 'selected';
  var cls_active = 'is-active';
  var cls_advisorStepHeading = 'advisor-active-step-heading';
  var cls_hidden = 'hidden';
  var cls_resultsHidden = 'd-none';
  var cls_option = 'advisor-step-slide';
  var cls_tab = 'filter-tabs-tab';
  var cls_step = 'advisor-step';
  var cls_stepBtn = 'step-btn';
  var cls_stepWrapper = 'advisor-step-wrapper';
  var cls_stepNav = 'advisor-step-nav';
  var cls_stepNavPrev = 'advisor-step-nav-prev';
  var cls_stepNavNext = 'advisor-step-nav-next';
  var attr_id = 'data-paId';
  var currentStep = 1;
  var numSteps = $('.advisor-step-wrapper').length;
  var $stepWrapper = $('.step-wrapper');
  var $recommendationsWrapper = $('.also-consider-content-wrapper');
  var $tabs = $('.filter-tabs');
  var isSlickInitialized = false;

  this.render = function() {
    $(`.${cls_tab} .step-btn`).on('click', function() {
      var stepNum = $(this).parent().index();
      gotoStep(stepNum);
      setAdvisorHeadingToActiveStepLabel();
      initializeSlick();
    });
    // Add event handlers to step options
    $(`.${cls_option}`).on('click', function() {
      var $this = $(this); 
      $this.toggleClass(cls_selected);
      // Deselect every other sibling, except if on step 5
      if (currentStep !== numSteps) {
        $this.siblings().removeClass(cls_selected);
      }
      // Update results
      fetchResults();
      reanchorPage();
      // If option is no longer selected, remove focus
      if (!$this.hasClass(cls_selected)) {
        document.activeElement.blur();
      }
    });
    // Advisor step nav (smaller screens)
    $(`.${cls_stepNav}`).on('click', function() {
      var $this = $(this);
      if ($this.hasClass(cls_stepNavPrev)) {
        gotoStep(currentStep - 2);
      } else if ($this.hasClass(cls_stepNavNext)) {
        gotoStep(currentStep);
      }
      initializeSlick();
    });
    // Check params for option
    var urlOpt = getParameterByName('option');
    if (urlOpt !== '') {
      var option = $('.' + cls_option + '[' + attr_id + '="' + urlOpt + '"]');
      currentStep = getCurrentStep(option) + 1;
      if (currentStep >= numSteps) {
        currentStep = 1;
      }
      option.addClass(cls_selected);
    }
    // Inits
    // Go to the next step
    gotoStep(currentStep - 1);
    setAdvisorHeadingToActiveStepLabel();
    window.addEventListener('resize', onWindowResize);
    onWindowResize();
    initializeSlick();
    // A preselected option from the query string still needs a filtered result set
    if (urlOpt !== '') {
      fetchResults();
    } else {
      afterResultsUpdate();
    }
  };

  // Post the current selections and let the server render the matching products.
  function fetchResults() {
    var selectedOptionIds = $('.' + cls_option + '.' + cls_selected).map(function() {
      return $(this).attr(attr_id);
    }).get();
    $.ajax({
      url: 'GetProductAdvisorResults',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ selectedOptionIds }),
      success: function(html) {
        $('.result-wrapper').replaceWith(html);
        afterResultsUpdate();
      },
    });
  }

  // Wire up the freshly rendered cards and toggle the recommendations section.
  function afterResultsUpdate() {
    var matchedResults = document.querySelectorAll('.matched-result');
    [].forEach.call(matchedResults, function(item) {
      attachTooltipEvents(item);
    });
    if ($('#alsoConsiderContent .matched-result').length === 0) {
      $('#alsoConsiderContent').addClass(cls_resultsHidden);
    } else {
      $('#alsoConsiderContent').removeClass(cls_resultsHidden);
    }
    LazyLoad();
  }

  function initializeSlick() {
    $(`.${cls_step}`).each(function() {
      var $this = $(this);
      var slidesToShow = $this.find(`.${cls_option}`).length;
      if (isSlickInitialized) {
        $this.slick('setPosition');
      } else {
        $this.slick({
          arrows: true,
          centerMode: false,
          draggable: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 2,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              }
            }
          ],
          swipe: false,
          touchMove: false,
        });
      }
      $this.removeClass(cls_hidden);
    });
    isSlickInitialized = true;
  }

  function setAdvisorHeadingToActiveStepLabel() {
    var advisorHeadingDiv = document.querySelector(`.${cls_advisorStepHeading}`);
    var activeStepBtn = document.querySelector(`.${cls_tab}.${cls_active} .${cls_stepBtn}`);
    if (activeStepBtn) {
      var label = activeStepBtn.getAttribute('aria-label');
      advisorHeadingDiv.textContent = label;
    }
  }

  function reanchorPage() {
    $('html, body').animate({
      scrollTop: 0,
    }, 0);
  }

  function onWindowResize() {
    if (window.innerWidth >= mobileBreakpoint) {
      // Assume desktop, show everything
      $tabs.show();
      $stepWrapper.show();
      $recommendationsWrapper.show();
    }
    updateStepLabels();
  }

  function updateStepLabels() {
    var isMobile = window.innerWidth < mobileBreakpoint;
    var stepBtnList = document.querySelectorAll('.step-btn');
    [].map.call(stepBtnList, function(item) {
      if (isMobile) {
        item.textContent = item.getAttribute('aria-label');
      } else {
        item.textContent = item.getAttribute('data-shortlabel');
      }
    });
  }
  
  function gotoStep(num) {
    currentStep = num + 1;
    setActiveTab();
    setActivePanel();
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function getCurrentStep(option) {
    return option.closest('.advisor-step-wrapper').index() + 1;
  }

  function setActivePanel() {
    $('.' + cls_stepWrapper).attr('hidden', true);
    $('.' + cls_stepWrapper + ':eq(' + (currentStep - 1) + ')').removeAttr('hidden');
  }

  function setActiveTab() {
    $('.' + cls_tab + '.' + cls_active).removeClass(cls_active);
    $('.' + cls_tab + '.' + cls_active + ' .step-btn').attr('aria-selected', false);
    $('.' + cls_tab + ':eq(' + (currentStep - 1) + ')').addClass(cls_active);
    $('.' + cls_tab + ':eq(' + (currentStep - 1) + ') .step-btn').attr('aria-selected', true);
  }

  function attachTooltipEvents(item) {
    addNewTooltipsToButtonGroup({
      btns: [
        item.querySelector('.match button'),
        item.querySelector('.no-match button'),
      ],
    });
  }
  return this;
}
var advisor = new Advisor();
advisor.render();
